import { shareSNS } from './lib/_share.js';
import { getScrollBar } from './lib/_tool.js';
import { nav } from './common/_nav.js';
import { masonry } from './lib/_masonry.js';

export var common = {
	scrl: "",
	beforeW: 0,
	init: function() {
		let $html = document.documentElement;
		document.addEventListener("keyup", function(e){
			//console.log(e.keyCode);
			if(e.keyCode === 71){
				if( !$html.classList.contains("show_grid") ){
					$html.classList.add("show_grid");
				}else{
					$html.classList.remove("show_grid");
				}
			}
		});
	},
	start: function(){
		let resizeFlag;
		let resizeTimer = null;
		let $body = document.getElementsByTagName('body')[0];
		
		common.resize();
		common.nav();
		
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			resizeTimer = null;
		};
		window.addEventListener("resize", function(){
			if( !$body.classList.contains("resize") ){
				$body.classList.add("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		}, false);
	},
	nav: ()=>{
		nav.register();
		let $btnScrolls = document.querySelectorAll("[data-scroll]");
		const eventListenersMultiple = [
			{ elements: $btnScrolls, type: "click", handler: { name: this, handleEvent: common.scrollToPos } }
		];
		eventListenersMultiple.forEach( ( el ) => {
			el.elements.forEach( ( element, index )=> {
				element.removeEventListener(el.type, el.handler, false);
				element.addEventListener(el.type, el.handler, false);
			});
		});
	},
	resize: ()=>{
		var winW 	= window.innerWidth;
		var winH 	= window.innerHeight;
		let $body 	= document.getElementsByTagName('body')[0];
		let isPage = $body.getAttribute("data-page");
		addressbarH();
		
		getScrollBar();
		
		let $movieDom = document.querySelector(".c-kv_movie");
		if( $movieDom ){
			if (window.matchMedia('all and (min-width : 664px)').matches) {
				if( !$movieDom.classList.contains("active") ){
					let h = window.innerWidth*9/16;
					$movieDom.style.height = h + "px";
				}
			}else{
				if( !$movieDom.classList.contains("active") ){
					$movieDom.style.height = "";
				}
			}
			
		}
		
		setTimeout(function(){
			if( $body.classList.contains("resize") ){
				$body.classList.remove("resize");
			}
			getScrollBar();
		},300);
		
		if( isPage === "top" ){
			let $target = document.querySelector(".c-list-magazine_summaries");
			masonry.resizeTop( $target );
		}
		
		function addressbarH(){
			if(common.beforeW != winW){
				// 100vh、アドレスバーが出てる時に対応
				let vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty("--vh", `${vh}px`);
			}
		}
		common.beforeW = winW;
	},
	scrollToPos: function(e){
		//console.log("scroll to Pos")
		e.preventDefault();
		let isPage = document.querySelector("#main").getAttribute("data-page");
		let id = e.currentTarget.getAttribute("href");
		if( document.querySelector(id) ){
			let posY = Math.floor( document.querySelector(id).getBoundingClientRect().top + window.pageYOffset );
			window.scrollTo({
				top: posY,
				behavior: 'smooth'
			});
			let $html = document.documentElement;
			if( $html.classList.contains("u-show_menu") ){
				$html.classList.remove("u-show_menu");
			}
		}
	}
}